import { EMPTY_STRING } from '../../../../../../constants/common'
import { REG_EXP_WYSIWYG_HTML_START } from '../../../../../../constants/regExp'
import { FORMIK_EMPTY_VALUE } from '../../../../../../constants/validation'
import {
  hasTinyMceHtmlVisibleContent,
  newLineToBrInHtml,
  plainTextToHtml,
} from '../../../../../../utils/html'
import { LISTING_FORM_FIELD_NAME_DESCRIPTION } from '../../../../../RentalPortalListing'

export function getListingDescriptionInitialValues(listing) {
  const description = listing?.description

  return {
    [LISTING_FORM_FIELD_NAME_DESCRIPTION]: REG_EXP_WYSIWYG_HTML_START.test(
      description || FORMIK_EMPTY_VALUE
    )
      ? newLineToBrInHtml(description)
      : plainTextToHtml(description),
  }
}

export function getListingDescriptionValue(values) {
  const description = values[LISTING_FORM_FIELD_NAME_DESCRIPTION]

  return hasTinyMceHtmlVisibleContent(description) ? description : EMPTY_STRING
}

export function getListingDescriptionPatchPayload(values) {
  return { description: getListingDescriptionValue(values) }
}
